/** Deutsche Bezeichnungen + Software-Zeile für Minecraft-Server (Übersicht & Einstellungen). */
import type { Server } from '../types';

export const DIFFICULTY_LABEL: Record<string, string> = { peaceful: 'Friedlich', easy: 'Leicht', normal: 'Normal', hard: 'Schwer' };
export const GAMEMODE_LABEL: Record<string, string> = { survival: 'Überleben', creative: 'Kreativ', adventure: 'Abenteuer', spectator: 'Zuschauer' };

interface Software { loader: string; loaderVersion: string | null; mcVersion: string | null }

const LOADER_TYPE = /^(vanilla|paper|purpur|spigot|bukkit|fabric|quilt|forge|neoforge)/i;
const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Nur echte MC-Versionen („1.21.1", „26.1.2") - bei Modpacks steht dort teils der Packname. */
export const mcVersionOf = (server: Pick<Server, 'version' | 'installed_modpack'>, software?: Software | null): string | null => {
  if (software?.mcVersion) return software.mcVersion;
  if (server.version && /^\d+\.\d+(\.\d+)?$/.test(server.version.trim())) return server.version.trim();
  return server.installed_modpack?.gameVersions?.[0] || null;
};

/** z.B. ["All the Mods 10 2.44", "NeoForge 21.1.248", "Minecraft 1.21.1"]. */
export function softwareParts(server: Pick<Server, 'type' | 'version' | 'installed_modpack'>, software?: Software | null): string[] {
  const t = String(server.type || '');
  if (t === 'bedrock') return ['Minecraft Bedrock', ...(server.version ? [server.version] : [])];

  const parts: string[] = [];
  const mp = server.installed_modpack;
  if (mp?.name) parts.push(mp.version && !mp.name.includes(mp.version) ? `${mp.name} ${mp.version}` : mp.name);

  if (software) {
    parts.push(software.loaderVersion ? `${software.loader} ${software.loaderVersion}` : software.loader);
  } else if (LOADER_TYPE.test(t)) {
    parts.push(/\s/.test(t) ? t : cap(t.toLowerCase())); // „Forge 1.20.1" steht so in der DB
  }
  const mc = mcVersionOf(server, software);
  if (mc && !parts.some((p) => p.includes(mc))) parts.push(`Minecraft ${mc}`);
  if (!parts.length) parts.push('Minecraft Java');
  return parts;
}
